import {BaseViewModel} from "../../../../infrastructure/models/base-view-model";
import {BettingAdPromotionDomainModel} from "./betting-ad.promotion.domain-model";
import type {BookmakerViewModel} from "../../../common/bookmaker/models/bookmaker-view-model";

export class BettingAdPromotionViewModel extends BaseViewModel {
  domainModel: BettingAdPromotionDomainModel;
  bookmaker: BookmakerViewModel;

  constructor(domainModel: BettingAdPromotionDomainModel, bookmaker: BookmakerViewModel) {
    super(domainModel);

    this.bookmaker = bookmaker;
    this.imageUrl = domainModel.imageUrl;
    this.bookmakerId = domainModel.bookmakerId;
    this.stars = domainModel.stars;
    this.rank = domainModel.rank;
    this.titles = domainModel.titles;
    this.ctaTitle = domainModel.ctaTitle;
    this.link = domainModel.link;
    this.reviewLink = domainModel.reviewLink;
  }
}
